import { render } from "./NuevoView.vue?vue&type=template&id=89f2294c"
import script from "./NuevoView.vue?vue&type=script&lang=js"
export * from "./NuevoView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__